import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { mainSiteUrl } from '@/mocks/categories';

export default function CtaSection() {
  const { t } = useTranslation();

  return (
    <section>
      <div className="mx-auto max-w-content px-4 md:px-6 py-14 md:py-20">
        <div className="relative overflow-hidden rounded-lg bg-primary-500 px-6 py-12 text-center md:px-12 md:py-16">
          <div className="absolute -right-10 -top-10 h-40 w-40 rounded-full bg-background-50/10" />
          <div className="absolute -bottom-12 -left-8 h-48 w-48 rounded-full bg-background-50/10" />
          <div className="relative">
            <h2 className="font-heading text-2xl font-bold text-background-50 dark:text-foreground-950 md:text-3xl">
              {t('cta.title')}
            </h2>
            <p className="mx-auto mt-3 max-w-xl text-sm text-background-50/90 dark:text-foreground-950/90 md:text-base">
              {t('cta.subtitle')}
            </p>
            <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
              <a
                href={mainSiteUrl}
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-background-50 px-6 py-3 text-sm font-semibold text-primary-700 hover:bg-background-100 transition-colors"
              >
                {t('cta.mainSite')}
                <i className="ri-external-link-line text-sm" />
              </a>
              <Link
                to="/articles/basetao-spreadsheet/"
                className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-6 py-3 text-sm font-semibold text-background-50 hover:bg-accent-600 transition-colors"
              >
                {t('cta.guide')}
                <i className="ri-arrow-right-line text-sm" />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}